import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dccaf6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container-dimmer d-flex align-items-center justify-content-center w-100 h-100"
}
const _hoisted_2 = { class: "container-dialog d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, null, -1))
const _hoisted_4 = { class: "flex-grow-1" }




export default /*#__PURE__*/_defineComponent({
  props: {
  headline: {
    type: String,
    required: false
  },
  show: {
    type: Boolean
  }
},
  emits: ["closed"],
  setup(__props, { emit }: { emit: ({
  (e: 'closed'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "content")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})